import React, { Component } from 'react';
import OptionButtonEvent from './OptionButtonEvent';
import * as EventOptionsUtils from '../EventOptionsUtils';
import Asset from '../../../requests/apa/Asset';
import NpvrUploader from '../../../AAF/Npvr/NpvrUploader';
import { NpvrUtil } from '../../../AAF/Npvr/NpvrUtil';
import { NPRV_SCHEDULED_STRING, NPVR_RECORDING_STRING, NPVR_RECORDED_STRING} from '../../../AAF/Npvr/Constans';
import Translator from '../../../requests/apa/Translator';




class RecordEvent extends Component {
    constructor(props = {}) {
        super(props);
        this.event = (this.props && this.props.data) || {};
        console.log(':::: [RecordEvent]', this.event);
        this.isSerie = NpvrUploader.isEventSerie(this.event) || false;
        this.isRecordable = EventOptionsUtils.hasEventRecordButton(this.event) || false;
        this.imageButton_record = Asset.get('playingLive_program_option_button_recording', '/images/ic_record.png');
        this.history = props && props.history || null;
        this.episodeParams = {
            // event_id: this.event.event_alf_id && this.event.event_alf_id !== null
            //     ? this.event.event_alf_id
            //     : this.event.id
            //         ? this.event.id
            //         : null,
            event_id: this.event.id || this.event.eventId || null,
            groupId: this.event.group_id ||  this.event.groupId || null,
            event_alf_id: this.event.event_alf_id || this.getEventAlfIdFromIdComposite(
                this.event.id_composite, 
                this.event.group_id ||  this.event.groupId || null, 
                this.event.id || this.event.eventId || null),
            channel_id: this.event.channel_id || this.event.eventNumber || null,            
            serieId: this.event.serieId || this.event.ext_series_id || null,
            ext_season_id: this.event.ext_season_id || null
        };
        this.state = {
            isRecording: NpvrUploader.isEventRecording(this.episodeParams.event_alf_id || this.episodeParams.event_id)
        };
        this.isRequest = false;
    }

    componentDidMount() {}

    componentWillMount() {}

    callBackGreen = () =>{
        this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric('mis contenidos', 'grabando');
        let urlMyContent = false;
        if(typeof this.props.getLinks === 'function'){
            const urls = this.props.getLinks();
            urlMyContent = urls && urls.miscontenidos && `/node/${urls.miscontenidos}`;
        }
        if(!urlMyContent) return;
        (typeof this.props.stopPlayer === 'function') && this.props.stopPlayer();
        this.history && this.history.push && (typeof this.history.push === 'function') && this.history.push(urlMyContent);
    }


    recordSerie = async () =>{
        if(this.isRequest) return;
        if (NpvrUtil.recordingIconEnable().enable) {
            let result = false;
            this.isRequest = true;
            this.handleCloseModal();
            try {
                this.sendMetric();
                result = await NpvrUploader.addSerie(
                    this.episodeParams.event_id,
                    this.episodeParams.event_alf_id,
                    this.episodeParams.groupId,
                    this.episodeParams.channel_id,
                    this.episodeParams.serieId,
                    this.callBackGreen,
                    this.episodeParams.ext_season_id
                );
                this.isRequest = false
            } catch (error) {
                this.isRequest = false;
            }
        }
    }

    handleCloseModal = () =>{
        const {handleClose = () => {}} = this.props;
        handleClose && typeof handleClose === 'function' && handleClose(null, () =>{});
    }

    cancelRecord = async (status) =>{
        if (NpvrUtil.recordingIconEnable().enable) {
            this.handleCloseModal();
            const recording_id = NpvrUploader.getRecordingIdByEventId(this.episodeParams.event_alf_id || this.episodeParams.event_id);
            const recording_delete_id = NpvrUploader.getRecordingDeleteIdByEventId(this.episodeParams.event_alf_id || this.episodeParams.event_id);
            if(recording_id){
                let recording_id_param = recording_id;
                if (recording_delete_id && (recording_id !== recording_delete_id)) {
                    recording_id_param = recording_delete_id;
                }
                const result = await NpvrUploader.delete(
                    this.episodeParams.event_id,
                    this.episodeParams.event_alf_id,
                    this.episodeParams.groupId,
                    recording_id_param,
                    status,
                    this.callBackGreen);
                const playerRecordingButton = document.querySelector(".video-player-control-button-recording");
                playerRecordingButton && playerRecordingButton.classList.remove("video-player-control-with-emphasis");
            }
          }

    }

    sendMetric = () =>{
        if(this.event && this.event.name){
            this.props && (typeof this.props.sendMetric === 'function') && this.props.sendMetric(this.event.name, 'grabar programa');
        }
    }

    recordEventNormalOrChapter = async (isEpisode = false) =>{
        if(this.isRequest) return;
        if (NpvrUtil.recordingIconEnable().enable) {
            let result = false;
            this.isRequest = true;
            this.handleCloseModal();
            try {
                this.sendMetric();
                result = await NpvrUploader.add(
                    this.episodeParams.event_id,
                    this.episodeParams.event_alf_id,
                    this.episodeParams.groupId,
                    this.episodeParams.channel_id,
                    isEpisode,
                    this.callBackGreen
                );
                this.isRequest = false
            } catch (error) {
                this.isRequest = false;
            }
        }
    }

    //Opciones para cuando una serie no se ha grabado
    getOptionsSeries_isNotRecording = () => {
        return (
            <div>
                <OptionButtonEvent title={'Grabar episodio'} image={this.imageButton_record} onClick={() =>{this.recordEventNormalOrChapter(true)}}/>
                <OptionButtonEvent title={'Grabar serie'} image={this.imageButton_record} onClick={()=>{this.recordSerie()}}/>
            </div>
        );
    };

    //Opciones para cuando una serie se ha grabado
    getOptionsSeries_isRecording = () => {
        const label = this.getTextCancelButton();
        return (
            <div>
                <OptionButtonEvent title={`${label.text || ''}`} image={this.imageButton_record} onClick={()=>{this.cancelRecord(label.status)}}/>
            </div>
        );
    };


    //Opciones para cuando un evento normal no se ha grabado
    getOptionsEventNormal_isNotRecording = () => {
        return (
            <div>
              <OptionButtonEvent title={Translator.get('panelOptions_sidemenu_item_program_button_recordPresentEvent', 'Grabar programa')} image={this.imageButton_record} onClick={() => {this.recordEventNormalOrChapter() }}/>
            </div>
        );
    };

    //Opciones para cuando un evento normal se ha grabado
    getOptionsEventNormal_isRecording = () => {
        const label = this.getTextCancelButton();
        return (
            <div>
                <OptionButtonEvent title={`${label.text || ''}`} image={this.imageButton_record} onClick={() =>{this.cancelRecord(label.status)}}/>
            </div>
        );
    };

    getTextCancelButton = () =>{
        const status = NpvrUploader.getRecordingStatusByEventId(this.episodeParams.event_alf_id || this.episodeParams.event_id);
        const statusText = NpvrUtil.parseIntStatusToString(status);
        let key = '';
        let defaultText = 'Cancelar grabación';

        switch(statusText){
            case NPRV_SCHEDULED_STRING:
                defaultText = 'Cancelar grabación';
                key = NPRV_SCHEDULED_STRING;
                break;
            case NPVR_RECORDED_STRING:
                defaultText = 'Eliminar grabación';
                key = NPVR_RECORDED_STRING;
                break;
            case NPVR_RECORDING_STRING:
                defaultText = 'Cancelar grabación';
                key = NPVR_RECORDING_STRING;
                break;
            default:
        }

        const text = Translator.get(`panelOptions_sidemenu_item_program_button_cancelRecording_${key}`, defaultText) || 'Cancelar grabación';
        return {
            status: `${statusText}`,
            text
        };
    }

    getOptions = () => {
        const { isRecording } = this.state;
        if(isRecording){
            // Si esta grabando
            if(this.isSerie){
                // si es una serie y esta grabando.
                return this.getOptionsSeries_isRecording();
            }else{
                // si es es un evento normal y esta grabando.
                return this.getOptionsEventNormal_isRecording();
            }
        }else{
            // si no esta grabando
            if(this.isSerie){
                //Si es una serie y no esta grabando
                return this.getOptionsSeries_isNotRecording();
            }else{
                // Si es evento normal y no esta grabando
                return this.getOptionsEventNormal_isNotRecording();
            }
        }

    }

    getEventAlfIdFromIdComposite(idComposite, groupId, eventId) {
        console.log("#### getEventAlfIdFromComposite, idComposite", idComposite, "groupId", groupId, "eventId", eventId )
        let eventAlfId = idComposite ? idComposite.replace(groupId, "") || null : null;
        eventAlfId = eventAlfId && eventAlfId != eventId ? eventAlfId : null;
        console.log("#### getEventAlfIdFromComposite:", eventAlfId)
        return eventAlfId;
    }

    render() {

        if (!this.isRecordable) {
            return null;
        }
        return this.getOptions();
    }
}

export default RecordEvent;



// WEBPACK FOOTER //
// ./src/components/EventOptions/components/RecordEvent.jsx